import { useRouterState } from "@tanstack/react-router";
import { useEffect, useState } from "react";

/**
 * Cienki pasek progresu na górze strony, widoczny gdy router robi nawigację
 * (status === "pending"). Daje natychmiastowy feedback "coś się dzieje" zanim
 * docelowa trasa zdąży zamontować Header / skeleton wyników.
 *
 * Ukrywamy pasek z 200 ms opóźnienia po zakończeniu — żeby nie migał na
 * błyskawicznych przejściach (cache hit).
 */
export function RouteProgressBar() {
  const status = useRouterState({ select: (s) => s.status });
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (status === "pending") {
      setVisible(true);
      return;
    }
    const t = setTimeout(() => setVisible(false), 200);
    return () => clearTimeout(t);
  }, [status]);

  if (!visible) return null;

  return (
    <div
      role="progressbar"
      aria-label="Ładowanie strony"
      aria-busy="true"
      className="fixed inset-x-0 top-0 z-[100] h-0.5 overflow-hidden bg-transparent"
    >
      <div className="h-full w-1/3 animate-[route-progress_1s_ease-in-out_infinite] rounded-r-full bg-gradient-sunset shadow-glow" />
      <style>{`
        @keyframes route-progress {
          0%   { transform: translateX(-100%); }
          50%  { transform: translateX(150%); }
          100% { transform: translateX(400%); }
        }
      `}</style>
    </div>
  );
}
